import mwcMarketsCore from 'mwc-markets-core';
import Gla from './src/gla.vue';

const { createCustomElement } = mwcMarketsCore;
createCustomElement(Gla);
export default Gla;
